jQuery(document).ready(function($) {
	
	if ($('#department_admins')[0] || $('#acf-field_5d412bb33f596')[0]) {
		
		// For "People In Article", we're only loading options that are already stored in the DB,
		// so go ahead and set them to "selected".
		$('#acf-field_5d412bb33f596 option').prop('selected', true);
		
		// Manually setting an inline style of width 100% at rbass4's request.
		$('#acf-field_5d412bb33f596').css('width', '100%');
		
		$('#department_admins, #acf-field_5d412bb33f596').select2({
			placeholder: 'Search for individual by name or username',
			allowClear: true,
			multiple: true,
			ajax: {
				url: function(params) {
					return 'https://www.elon.edu/Directories/xml.ashx';
				},
				data: function(params) {
					return {
						full: false,
						type: 'json',
						q: params.term
					};
				},
				dataType: 'json',
				type: 'GET',
				processResults: function(data, params) {
					//console.log(params);
					//console.log('data:');
					//console.log(data.ArrayOfEmployee.Employee);
					return {
						results: $.map(data.ArrayOfEmployee.Employee, function(item) {
							var name = item.FirstName + ' ' + item.LastName;
							var username = item.Username;
							var email = item.EmailAddress;
							var position = item.Position;
							var dept = item.DepartmentName;
							var photo = 'https://www.elon.edu/PhotoManager/GetImage.ashx?user=' + item.Username + '&crop=5:7&w=64';
							return {
								id: item.Username + ',' + name,
								text: name,
								html: '<div class="directory-item"><img alt="" src="' + photo + '" style="float: left; margin-right: 6px;" /> <strong>' + name + '</strong><br />' + email + '<br />' + position + '<br />' + dept + '<div style="clear: both; height: 1px;"></div></div>',
								title: name,
							};
						})	
					};
				}
			},
			escapeMarkup: function(markup) {
				return markup;
			},
			templateResult: function(data) {
				return data.html;
			},
			templateSelection: function(data) {
				return data.text;
			}
		});

	}
	
	if ($('#search-author')[0] || $('#tag-user')[0]) {
		
		$('#search-author, #tag-user').select2({
			allowClear: true,
			multiple: true,
			ajax: {
				url: function(params) {
					return 'https://www.elon.edu/Directories/xml.ashx';
				},
				data: function(params) {
					return {
						full: false,
						type: 'json',
						q: params.term
					};
				},
				dataType: 'json',
				type: 'GET',
				processResults: function(data, params) {
					//console.log(params);
					//console.log('data:');
					//console.log(data.ArrayOfEmployee.Employee);
					return {
						results: $.map(data.ArrayOfEmployee.Employee, function(item) {
							var name = item.FirstName + ' ' + item.LastName;
							var username = item.Username;
							var email = item.EmailAddress;
							var position = item.Position;
							var dept = item.DepartmentName;
							var photo = 'https://www.elon.edu/PhotoManager/GetImage.ashx?user=' + item.Username + '&crop=1:1&w=120';
							return {
								id: item.Username + ',' + name,
								text: name,
								html: '<div class="directory-item"><div class="directory-item--img"><img alt="" src="' + photo + '" /></div><div class="directory-item--text"><span class="directory-name"><strong>' + name + '</strong></span><span class="directory-title">' + position + '</span><span class="directory-email">' + email + '</span></div>',
								title: name,
							};
						})	
					};
				}
			},
			escapeMarkup: function(markup) {
				return markup;
			},
			templateResult: function(data) {
				return data.html;
			},
			templateSelection: function(data) {
				return data.text;
			}
		});
		
	}
	
});